import { AegRequestErrors, AegRequestField, AegRequestForm } from '../../../../../models/newAEG';
import { AegRepairScopeEnum, AegStatusEnum } from '../../../../../models/newAEG';

export const AEG_REQUIRED_FIELDS: AegRequestField[] = [
    'requestType',
    'approvalType',
    'responsible',
    'dn',
    'regional',
    'chassis',
    'licensePlate',
    'vehicleType',
    'customer',
    'odometer',
    'hourMeter',
    'repairDate',
    'serviceOrder',
    'warrantyRequest',
    'serviceType',
    'repairTotal',
    'laborTotal',
    'serviceCondition',
    'hasThirdParty',
    'repairScope',
    'breakdown',
    'customerComplaint',
    'dnDiagnosis',
    'dnJustification',
    'moveTo',
];

const THIRD_PARTY_REQUIRED_FIELDS: AegRequestField[] = [
    'thirdPartyServices',
    'thirdPartyInvoiceValue',
    'thirdPartyInvoiceNumber',
];

const PARTIAL_REPAIR_REQUIRED_FIELDS: AegRequestField[] = ['repairPercentage'];

export const getRequiredFields = (values: AegRequestForm): AegRequestField[] => {
    if (values.moveTo !== AegStatusEnum.PENDING_ANALYSIS) {
        return [];
    }

    return [
        ...AEG_REQUIRED_FIELDS,
        ...(values.hasThirdParty ? THIRD_PARTY_REQUIRED_FIELDS : []),
        ...(values.repairScope === AegRepairScopeEnum.PARTIAL ? PARTIAL_REPAIR_REQUIRED_FIELDS : []),
    ];
};

const isBlank = (value: AegRequestForm[AegRequestField]) => {
    if (typeof value === 'string') {
        return value.trim().length === 0;
    }
    if (typeof value === 'number') {
        return value === 0;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return value == null;
};

export const validateRequiredFields = (values: AegRequestForm, requiredFields: AegRequestField[]): AegRequestErrors => {
    const errors: AegRequestErrors = {};
    requiredFields.forEach(field => {
        if (isBlank(values[field])) {
            errors[field] = true;
        }
    });
    return errors;
};
